export default {
  namespaced: true,
  state: {
    type: {
      barrel: 1,
      clearChocolate: 2,
      chocolateWithIngredients: 3,
      figurine: 4,
      creams: 5,
      coatingProductInCoolingTunnel: 6,
    },
    typeList: [
      { id: 1, name: "Bęben" },
      { id: 2, name: "Czysta czekolada" },
      { id: 3, name: "Czekolada z dodatkami" },
      { id: 4, name: "Figurki" },
      { id: 5, name: "Kremy" },
      { id: 6, name: "Oblewany produkt w tunelu chłodniczym" },
    ],
  },
  mutations: {},
  actions: {
    //Asyncrhoniczne
  },
};
